export default __webpack_public_path__ + "static/media/default-img.df367193.jpg";